export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}

export enum LIST_MATCHING_WORKSPACE_TAB {
  DETAILS = 'Details',
  EXPLORE = 'Explore',
  SEGMENT = 'Segment',
  PREVIEW = 'Preview',
}

export enum Environment {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}
